'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaFighterJet = function FaFighterJet(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm39.9 21.3q-0.1 0.7-6 2l-7.3 0.7-4.7 1.3h-1.3l-6.1 7.3h1.4q0.6 0 1 0.1t0.4 0.3-0.4 0.2-1 0.1h-6.6v-0.7h1.3v-8.6h-3.3l-4 4.6h-2l-0.6-0.6v-4h0.6v-0.7h2.7v-0.1l-4-0.5v-2.7l4-0.5v-0.2h-2.7v-0.6h-0.6v-4l0.6-0.7h2l4 4.7h3.3v-8.7h-1.3v-0.6h6.6q0.6 0 1 0.1t0.4 0.2-0.4 0.2-1 0.1h-1.4l6.1 7.3h1.3l4.7 1.4 7.3 0.6q5.4 1.2 5.9 2z' })
        )
    );
};

exports.default = FaFighterJet;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/fighter-jet.js
// module id = 573
// module chunks = 79611799117203